/* eslint-disable */

import { rootApi } from '../rootApi';

// Helper function to get current language ID
const getCurrentLanguageIdFromParams = (params) => {
    // If LanguageId is explicitly provided, use it
    if (params?.LanguageId !== undefined) {
        return params.LanguageId;
    }
    // Default fallback
    return 1;
};

export const sapApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getItemCodes: builder.query({
            query: (params) => {
                // Base parameters
                const queryParams = {
                    LanguageId: getCurrentLanguageIdFromParams(params),
                    RowCount: params?.RowCount !== undefined ? params.RowCount : 30,
                    SearchText: params?.SearchText || '',
                    ...(params?.ClaimId ? { ClaimId: params.ClaimId } : {})
                };

                return {
                    url: 'v1/sap/itemcodes',
                    params: queryParams
                };
            },
            transformResponse: (response) => {
                // Check if response has the expected structure with data property
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data)) {
                        return response.data;
                    }

                    // If response itself is an array, return it directly
                    if (Array.isArray(response)) {
                        console.log('✅ Response is already an array with', response.length, 'items');
                        return response;
                    }
                }

                // Fallback: return empty array if structure doesn't match
                console.warn('⚠️ Response structure not as expected, returning empty array');
                return [];
            },
            // Keep track of API state for debugging
            onQueryStarted: async (arg, { queryFulfilled }) => {
                console.log('🚀 getItemCodes query started with:', arg);
                try {
                    const result = await queryFulfilled;
                    console.log('✅ getItemCodes query fulfilled:', result);
                } catch (error) {
                    console.error('❌ getItemCodes query failed:', error);
                }
            },
            providesTags: ['Sap']
        }),

        getWarrantyClaimsItemDropdown: builder.query({
            query: (params) => {
                const queryParams = {
                    LanguageId: getCurrentLanguageIdFromParams(params),
                    SearchText: params?.SearchText || '',
                    WarrantyClaimId: params?.WarrantyClaimId
                };

                return {
                    url: 'v1/warrantyclaimsitem/getitemsdropdown',
                    method: 'GET',
                    params: queryParams
                };
            },
            transformResponse: (response) => {
                // Check if response has the expected structure with data property
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data)) {
                        return response.data;
                    }

                    // If response itself is an array, return it directly
                    if (Array.isArray(response)) {
                        console.log('✅ WarrantyClaimsItemDropdown response is already an array with', response.length, 'items');
                        return response;
                    }
                }

                // Fallback: return empty array if structure doesn't match
                console.warn('⚠️ WarrantyClaimsItemDropdown response structure not as expected, returning empty array');
                return [];
            },
            // Keep track of API state for debugging
            onQueryStarted: async (arg, { queryFulfilled }) => {
                console.log('🚀 getWarrantyClaimsItemDropdown query started with:', arg);
                try {
                    const result = await queryFulfilled;
                    console.log('✅ getWarrantyClaimsItemDropdown query fulfilled:', result);
                } catch (error) {
                    console.error('❌ getWarrantyClaimsItemDropdown query failed:', error);
                }
            },
            providesTags: (result, error, { WarrantyClaimId }) => [{ type: 'Sap', id: `warranty-dropdown-${WarrantyClaimId}` }]
        }),

        // SAP Measure List (MEINS)
        getMeasureList: builder.query({
            query: (params = {}) => ({
                url: 'v1/sap/GetMeasureList',
                method: 'GET',
                params: {
                    LanguageId: params.languageId || params.LanguageId || 2,
                    ...(params.searchText && { SearchText: params.searchText })
                }
            }),
            transformResponse: (response) => {
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data)) {
                        return response.data;
                    }
                    if (Array.isArray(response)) {
                        return response;
                    }
                }
                return [];
            },
            providesTags: ['SapMeasure']
        }),

        // SAP Exchange Rate List (Currency)
        getExchangeRateList: builder.query({
            query: (params = {}) => ({
                url: 'v1/sap/GetExchangeRateList',
                method: 'GET',
                params: {
                    ...(params.searchText && { SearchText: params.searchText }),
                    ...(params.isDealer && { DealerCurrency: true })
                }
            }),
            transformResponse: (response) => {
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data)) {
                        return response.data;
                    }
                    if (Array.isArray(response)) {
                        return response;
                    }
                }
                return [];
            },
            providesTags: ['SapExchangeRate']
        })
    })
});

export const { 
    useGetItemCodesQuery,
    useLazyGetItemCodesQuery,
    useGetWarrantyClaimsItemDropdownQuery,
    useGetMeasureListQuery,
    useGetExchangeRateListQuery
} = sapApi;
